// Same-origin relative path only, so a crafted ?redirect= cannot send a
// freshly signed-in user to another site. /login and /signup are rejected to
// avoid redirect loops.
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/;
const AUTH_PAGE = /^\/(login|signup)/i;

function decodeSafely(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function getSafeRedirect(raw: string | null | undefined, fallback = '/'): string {
  if (!raw || CONTROL_CHARS.test(raw)) return fallback;
  const value = raw.trim();
  if (!value.startsWith('/') && !/^https?:\/\//i.test(value)) return fallback;

  let url: URL;
  try {
    url = new URL(value, window.location.origin);
  } catch {
    return fallback;
  }
  if (url.origin !== window.location.origin) return fallback;

  const path = decodeSafely(url.pathname);
  if (path.startsWith('//') || path.includes('\\') || AUTH_PAGE.test(path)) return fallback;

  return `${url.pathname}${url.search}${url.hash}`;
}
